import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { authenticationActions } from './authentication.actions';
import { UserConnected } from './types';
import { GenericState, IState } from '../../../common/store/types';
import { onApiCall } from '../../../common/store/generic.reducer';

export interface IAuthenticationState extends IState<any> {
  userConnected: UserConnected;
  forgotPassword: GenericState<boolean>;
  resetPassword: GenericState<boolean>;
  changePassword: GenericState<boolean>;
}

export const authenticationInitialState: IAuthenticationState = {
  userConnected: { username: '', email: '' },
  forgotPassword: new GenericState<boolean>(),
  resetPassword: new GenericState<boolean>(),
  changePassword: new GenericState<boolean>(),
};

const authenticationReducers = [
  on(
    authenticationActions.setUserConnected,
    (state: IAuthenticationState, { userConnected }) => ({
      ...state,
      userConnected: userConnected,
    }),
  ),
  ...onApiCall<boolean>(authenticationActions.forgotPassword, 'forgotPassword'),
  ...onApiCall<boolean>(authenticationActions.resetPassword, 'resetPassword'),
  ...onApiCall<boolean>(authenticationActions.changePassword, 'changePassword'),
];

export const authenticationReducer = createReducer(
  authenticationInitialState,
  ...authenticationReducers,
) as ActionReducer<IAuthenticationState, Action>;

export function useReducerFunc(state: any | undefined, action: Action) {
  return authenticationReducer(state, action);
}
